import { render, staticRenderFns } from "./FilePreviewModal.vue?vue&type=template&id=56510460&scoped=true"
import script from "./FilePreviewModal.vue?vue&type=script&lang=js"
export * from "./FilePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./FilePreviewModal.vue?vue&type=style&index=0&id=56510460&prod&scoped=true&lang=scss"
import style1 from "./FilePreviewModal.vue?vue&type=style&index=1&id=56510460&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56510460",
  null
  
)

export default component.exports